import Image from 'next/image';

import { ProductImage } from '../../../interface/strapi';

/* eslint-disable-next-line */
type ProductsBannerProps = {
  bannerImage: { data: ProductImage };
  bannerDescription: string;
  bannerTitle: string;
};

export function ProductsBanner(props: ProductsBannerProps) {
  const { bannerImage, bannerDescription, bannerTitle } = props;

  return (
    <div className="w-full flex flex-col items-center justify-center md:flex-row h-max bg-secondaryGray lg:px-32">
      <div className="w-full">
        <Image
          alt="Category Banner"
          blurDataURL="/icons/blur-placeholder.png"
          height={bannerImage?.data?.attributes?.height}
          layout="responsive"
          placeholder="blur"
          src={bannerImage?.data?.attributes?.url}
          width={bannerImage?.data?.attributes?.width}
        />
      </div>

      <div className="w-full h-full py-4 flex flex-col px-12">
        <p className="text-center text-header6 lg:text-header5 font-ChronicleDisplaySemibold">
          {bannerTitle}
        </p>
        <p className="text-center text-subtitle mt-4 leading-5">
          {bannerDescription}
        </p>
      </div>
    </div>
  );
}

export default ProductsBanner;
